import { Accordion, AccordionTab } from 'primereact/accordion'
import about from '@/styles/frequent_questions/index.module.scss'

export const FrequentQuestions = ({ title, description }) => {
  return (
    <Accordion activeIndex={1} className={about.container_question} style={{ width: '100%', borderRadius: '20px', overflow: 'hidden', boxShadow: '3px 4px 5px 2px rgba(0,0,0,0.2)' }}>
      <AccordionTab header={title} className={about.my_accordion}>

        <p className={about.my_paragraph}>{description}</p>
      </AccordionTab>
    </Accordion>

  )
}
